import { useEffect, useState } from "react";

export default function useSonderLoading(sonderEvents) {
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoading(false), 300);
    return () => clearTimeout(timer);
  }, [sonderEvents]);

  return showLoading;
}
